<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleDateChange="handleDateChange"
                >
                    <template v-slot:formBtn>
                        <a-divider direction="vertical" />
                        <a-alert class="countBar">
                            <span>{{$t('kpiDailyReport.dateTip')}}</span>
                        </a-alert>
                    </template>
                </Form>
            </div>
            <!-- <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div> -->
        </div>

        <Table 
            class="saleTable"
            ref="tableRef"
            :table="table"
        >
            <template v-slot:operate>
                <a-button v-permission="'setting.dashboard.exportFile'" type="primary" size="mini" :disabled="importing" @click="handle('orderDetailExport')">
                    <icon-export size="13" style="marginRight:5px;"/>
                    {{ $t('kpiDailyReport.orderDetailExport') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.dashboard.erpShipExport'"/>
                <a-button v-permission="'setting.dashboard.erpShipExport'" type="primary" size="mini" :disabled="importing" @click="handle('erpShipExport')">
                    <icon-export size="13" style="marginRight:5px;"/>
                    {{ $t('kpiDailyReport.erpShipExport') }}
                </a-button>
                <a-divider direction="vertical"  v-permission="'setting.dashboard.mesShipExport'"/>
                <a-button v-permission="'setting.dashboard.mesShipExport'" type="primary" size="mini" :disabled="importing" @click="handle('mesShipExport')">
                    <icon-export size="13" style="marginRight:5px;"/>
                    {{ $t('kpiDailyReport.mesShipExport') }}
                </a-button>
            </template>

            <template v-slot:columns="{ props }">
                <!-- 签收 -->
                <!-- <div v-if="props.column.key == 'sign_month_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.sign_month_quantity }}</div>
                    <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_month_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.sign_month_rate_val <= 80 || props.record.sign_month_rate  == '0%'}">
                            {{ props.record.sign_month_rate }}
                        </div>
                    </div>
                </div>
                <div v-if="props.column.key == 'sign_year_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.sign_year_quantity }}</div>
                    <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_year_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.sign_year_rate_val <= 80 || props.record.sign_year_rate == '0%'}">
                            {{ props.record.sign_year_rate }}
                        </div>
                    </div>
                </div> -->

                <!-- 发货 -->
                <div v-if="props.column.key == 'delivery_month_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.delivery_month_quantity }}</div>
                    <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_month_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.delivery_month_rate_val <= 80 || props.record.delivery_month_rate  == '0%'}">
                            {{ props.record.delivery_month_rate }}
                        </div>
                    </div>
                    <!-- <div class="slot_cell_right">
                        {{ props.record.delivery_month_rate }}
                    </div> -->
                </div>
                <div v-if="props.column.key == 'delivery_year_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.delivery_year_quantity }}</div>
                    <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_year_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.delivery_year_rate_val <= 80 || props.record.delivery_year_rate == '0%'}">
                            {{ props.record.delivery_year_rate }}
                        </div>
                    </div>
                    <!-- <div class="slot_cell_right">
                        {{ props.record.delivery_year_rate }}
                    </div> -->
                </div>
                
                <!-- 订单 -->
                <div v-if="props.column.key == 'order_month_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.order_month_quantity }}</div>
                    <!-- <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_month_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.order_month_rate_val <= 80 || props.record.order_month_rate  == '0%'}">
                            {{ props.record.order_month_rate }}
                        </div>
                    </div> -->
                </div>
                <div v-if="props.column.key == 'order_year_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.order_year_quantity }}</div>
                    <!-- <div class="slot_cell_right">
                        <div class="slot_cell_right_top">
                            {{ props.record.order_year_goal }}
                        </div>
                        <div :class="{'slot_cell_right_bottom': props.record.order_year_rate_val <= 80 || props.record.order_year_rate == '0%'}">
                            {{ props.record.order_year_rate }}
                        </div>
                    </div> -->
                </div>
                
                <!-- 取消 -->
                <div v-if="props.column.key == 'cancel_month_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.cancel_month_quantity }}</div>
                    <div class="slot_cell_right">
                        {{ props.record.cancel_month_rate }}
                    </div>
                </div>
                <div v-if="props.column.key == 'cancel_year_quantity'" class="slot_cell">
                    <div class="slot_cell_left">{{ props.record.cancel_year_quantity }}</div>
                    <div class="slot_cell_right">
                        {{ props.record.cancel_year_rate }}
                    </div>
                </div>
            </template>
        </Table>

        <Table 
            class="shipTable"
            ref="tableRef"
            :table="shipTable"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.record.warehouse" class="warehouse">
                    <div class="warehouse_left">
                        {{ props.record.warehouse }}
                    </div>
                    <div class="warehouse_right" v-if="props.record.warehouse !== 'TTL'">
                        <div class="warehouse_right_center">B2C</div>
                        <div class="warehouse_right_top">B2B</div>
                        <div class="warehouse_right_bottom">C&C</div>
                    </div>
                </div>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { KpiDailyReportApi } from '@/api/KpiDailyReportApi.js';
    import { OrderApi } from '@/api/OrderApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { KpiDailyReportQuery } from './queryConfig/KpiDailyReportQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';

    const localeStore = useLocale()

    const { t } = useI18n()

    const queryForm = reactive(KpiDailyReportQuery)
    const exporting = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '类型',
                title: t('kpiDailyReport.item'),
                dataIndex: 'type',
                key:'type',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'center',
            },
            // {
            //     // title: '签收数',
            //     title: t('kpiDailyReport.delievered'),
            //     width:'120',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'center',
            //     children:[
            //         {
            //             title: '',
            //             dataIndex: 'sign_quantity',
            //             key:'sign_quantity',
            //             align:'center',
            //             ellipsis:true,
            //             tooltip:true,
            //         }, 
            //         {
            //             title: t('kpiDailyReport.mtd'),
            //             dataIndex: 'sign_month_quantity',
            //             key:'sign_month_quantity',
            //             align:'center',
            //             ellipsis:true,
            //             tooltip:true,
            //             slotName:'slot'
            //         }, 
            //         {
            //             title: t('kpiDailyReport.ytd'),
            //             dataIndex: 'sign_year_quantity',
            //             key:'sign_year_quantity',
            //             align:'center',
            //             ellipsis:true,
            //             tooltip:true,
            //             slotName:'slot'
            //         }, 
            //     ]
            // },
            {
                // title: '发货数',
                title: t('kpiDailyReport.shipOut'),
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
                children:[
                    {
                        title: '',
                        dataIndex: 'delivery_quantity',
                        key:'delivery_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('kpiDailyReport.mtd'),
                        dataIndex: 'delivery_month_quantity',
                        key:'delivery_month_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                    {
                        title: t('kpiDailyReport.ytd'),
                        dataIndex: 'delivery_year_quantity',
                        key:'delivery_year_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                ]
            },
            {
                // title: '订单数',
                title: t('kpiDailyReport.orders'),
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
                children:[
                    {
                        title: '',
                        dataIndex: 'order_quantity',
                        key:'order_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('kpiDailyReport.mtd'),
                        dataIndex: 'order_month_quantity',
                        key:'order_month_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                    {
                        title: t('kpiDailyReport.ytd'),
                        dataIndex: 'order_year_quantity',
                        key:'order_year_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                ]
            },
            {
                // title: '退货数',
                title: t('kpiDailyReport.cancelled'),
                dataIndex: 'record_week',
                key:'record_week',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
                children:[
                    {
                        title: '',
                        dataIndex: 'cancel_quality',
                        key:'cancel_quality',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('kpiDailyReport.mtd'),
                        dataIndex: 'cancel_month_quantity',
                        key:'cancel_month_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                    {
                        title: t('kpiDailyReport.ytd'),
                        dataIndex: 'cancel_year_quantity',
                        key:'cancel_year_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                        slotName:'slot'
                    }, 
                ]
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })
    const prevDate = ref(timestampToDate((dateToTimestamp(getNowDate()) - 60 * 60 * 24) * 1000).split(' ')[0])

    console.log(prevDate.value,'date')

    const shipTable = ref({
        datas:[],
        columns:[
            {
                // title: '仓库',
                title: t('kpiDailyReport.item'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'center',
                slotName:'slot',
            },
            {
                // title: '发货数据',
                title: t('kpiDailyReport.dailyShipmentData'),
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
                children:[
                    {
                        title: t('kpiDailyReport.ytd'),
                        dataIndex: 'delivery_year_quantity',
                        key:'delivery_year_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('kpiDailyReport.mtd'),
                        dataIndex: 'delivery_month_quantity',
                        key:'delivery_month_quantity',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity1',
                        key:'delivery_quantity1',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity2',
                        key:'delivery_quantity2',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity3',
                        key:'delivery_quantity3',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity4',
                        key:'delivery_quantity4',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity5',
                        key:'delivery_quantity5',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity6',
                        key:'delivery_quantity6',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: '',
                        dataIndex: 'delivery_quantity7',
                        key:'delivery_quantity7',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                ]
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
            dataSpanMethod:({record, column, rowIndex, columnIndex})=>{
                console.log({record, column, rowIndex, columnIndex},'kkkk')
                let indexArr = [0, 3, 6, 9]
                if (indexArr.includes(rowIndex) && columnIndex == 0) {
                    return {rowspan: 3}
                }
                if (rowIndex === shipTable.value.datas.length - 1 && columnIndex == 1) {
                    return {colspan: 1}
                }
            },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            // case 'search':
            //     getPlanList()
            //     break;
            // case 'reset':
            //     queryForm.formField.forEach(i=>{
            //         queryForm.formData[i.key] = ''
            //     })
            //     getPlanList()
            //     break;
            case 'orderDetailExport':
                // if(!queryForm.formData.date){
                //     Message.error(t('base.date')+ ' ' +t('base.noEmpty'))
                //     return
                // }
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('orderDetailExport')
                    }
                });
                break;
            case 'erpShipExport':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('erpShipExport')
                    }
                });
                break;
            case 'mesShipExport':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('mesShipExport')
                    }
                });
                break;
        }
    }

    const handleDateChange = (val)=>{
        console.log(val,'mmnn')
        queryForm.date = val
        getSaleList()
        getShipList()
    }

    // 导出订单明细
    const exportFile = async (type)=>{
        let param = {
            date: queryForm.date || '',
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = type == 'orderDetailExport'? await KpiDailyReportApi.getInstance().exportOrderDetail(param)
                : type == 'erpShipExport'? await KpiDailyReportApi.getInstance().exportERPShip(param)
                : await KpiDailyReportApi.getInstance().exportMESShip(param)

        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = type == 'orderDetailExport'? `${t('kpiDailyReport.orderDetailExport')}.xlsx` 
                       : type == 'erpShipExport'? `${t('kpiDailyReport.erpShipExport')}.xlsx`
                       : `${t('kpiDailyReport.mesShipExport')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }


    // 获取销量列表
    const getSaleList = async()=>{
        console.log(queryForm.date, 'queryForm.date,')
        let param = {
            date: !queryForm.date? '' : queryForm.date 
        }
        table.value.configs.loading = true
        let res = await KpiDailyReportApi.getInstance().getSaleList(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                // i.sign_month_rate = i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.sign_month_quantity, i.order_month_goal), 100)) + '%'
                // i.sign_year_rate = i.order_year_goal == 0? '0%' : Math.round(multiply(divide(i.sign_year_quantity, i.order_year_goal), 100)) + '%'
                // i.sign_month_rate_val = i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.sign_month_quantity, i.order_month_goal), 100))
                // i.sign_year_rate_val = i.order_year_goal == 0? '0%' : Math.round(multiply(divide(i.sign_year_quantity, i.order_year_goal), 100))

                i.delivery_month_rate = i.order_month_quantity == 0 || i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.delivery_month_quantity, i.order_month_goal), 100)) + '%'
                i.delivery_year_rate = i.order_year_quantity == 0 || i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.delivery_year_quantity, i.order_year_goal), 100)) + '%'
                i.delivery_month_rate_val = i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.delivery_month_quantity, i.order_month_goal), 100))
                i.delivery_year_rate_val = i.order_year_goal == 0? '0%' : Math.round(multiply(divide(i.delivery_year_quantity, i.order_year_goal), 100))
                console.log(i.delivery_year_quantity, i.order_year_goal, divide(i.delivery_year_quantity, i.order_year_goal), 'hhhh')

                // i.order_month_rate = i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.order_month_quantity, i.order_month_goal), 100)) + '%'
                // i.order_year_rate = i.order_year_goal == 0? '0%' : Math.round(multiply(divide(i.order_year_quantity, i.order_year_goal), 100)) + '%'
                // i.order_month_rate_val = i.order_month_goal == 0? '0%' : Math.round(multiply(divide(i.order_month_quantity, i.order_month_goal), 100))
                // i.order_year_rate_val = i.order_year_goal == 0? '0%' : Math.round(multiply(divide(i.order_year_quantity, i.order_year_goal), 100))

                i.cancel_month_rate = i.delivery_month_quantity == 0? '0%' : Math.round(multiply(divide(i.cancel_month_quantity, i.delivery_month_quantity), 100)) + '%'
                i.cancel_year_rate = i.delivery_year_quantity == 0? '0%' : Math.round(multiply(divide(i.cancel_year_quantity, i.delivery_year_quantity), 100)) + '%'
            
                // table.value.columns[1].children.forEach(i=>{
                //     switch(i.key){
                //         case 'sign_quantity':
                //             if(!queryForm.date){
                //                 i.title = prevDate.value.split('-')[2] + '.' + prevDate.value.split('-')[1] + '.' + prevDate.value.split('-')[0]
                //             }else{
                //                 i.title = queryForm.date.split('-')[2] + '.' + queryForm.date.split('-')[1] + '.' + queryForm.date.split('-')[0]
                //             }
                //             break;
                //     }
                // })
                table.value.columns[1].children.forEach(i=>{
                    switch(i.key){
                        case 'delivery_quantity':
                            if(!queryForm.date){
                                i.title = prevDate.value.split('-')[2] + '.' + prevDate.value.split('-')[1] + '.' + prevDate.value.split('-')[0]
                            }else{
                                i.title = queryForm.date.split('-')[2] + '.' + queryForm.date.split('-')[1] + '.' + queryForm.date.split('-')[0]
                            }
                            break;
                    }
                })
                table.value.columns[2].children.forEach(i=>{
                    switch(i.key){
                        case 'order_quantity':
                            if(!queryForm.date){
                                i.title = prevDate.value.split('-')[2] + '.' + prevDate.value.split('-')[1] + '.' + prevDate.value.split('-')[0]
                            }else{
                                i.title = queryForm.date.split('-')[2] + '.' + queryForm.date.split('-')[1] + '.' + queryForm.date.split('-')[0]
                            }
                            break;
                    }
                })
                table.value.columns[3].children.forEach(i=>{
                    switch(i.key){
                        case 'cancel_quality':
                            if(!queryForm.date){
                                i.title = prevDate.value.split('-')[2] + '.' + prevDate.value.split('-')[1] + '.' + prevDate.value.split('-')[0]
                            }else{
                                i.title = queryForm.date.split('-')[2] + '.' + queryForm.date.split('-')[1] + '.' + queryForm.date.split('-')[0]
                            }
                            break;
                    }
                })
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 获取发货列表
    const getShipList = async()=>{
        let param = {
            date: !queryForm.date? '' : queryForm.date 
        }
        shipTable.value.configs.loading = true
        let res = await KpiDailyReportApi.getInstance().getShipList(param)
        if(res.code == 0){
            if(res.data.days.length > 0){
                shipTable.value.columns[1].children.forEach(i=>{
                    switch(i.key){
                        case 'delivery_quantity1':
                            i.title = res.data.days[0]
                            break;
                        case 'delivery_quantity2':
                            i.title = res.data.days[1]
                            break;
                        case 'delivery_quantity3':
                            i.title = res.data.days[2]
                            break;
                        case 'delivery_quantity4':
                            i.title = res.data.days[3]
                            break;
                        case 'delivery_quantity5':
                            i.title = res.data.days[4]
                            break;
                        case 'delivery_quantity6':
                            i.title = res.data.days[5]
                            break;
                        case 'delivery_quantity7':
                            i.title = res.data.days[6]
                            break;
                    }
                })
            }

            shipTable.value.datas = res.data.day_delivery_shipment_report_vos
            shipTable.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }


    onMounted(()=>{
        getSaleList()
        getShipList()
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

// 表格
/deep/ .arco-table-td{
    padding: 0;
    border-right: 1px solid #eee;
}

/deep/ .arco-table .arco-table-cell{
    padding: 0 !important;
}

/deep/ .arco-table-th{
    padding: 9px 16px !important;
}

.tableList{
    /deep/ .arco-table-th{
        background: #fff;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        font-size: 13px;
        font-weight: 600;
    }
}


/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .table_pagination{
    display:none;
} 

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-table-th{
    background: #fff;
    font-weight: 600;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

.saleTable{
    /deep/ .arco-table-tr:nth-of-type(1){
        .arco-table-th:nth-of-type(2){
            background: #a2e0aa;
        }

        .arco-table-th:nth-of-type(3){
            background: #e4f8d4;
        }

        .arco-table-th:nth-of-type(4){
            background: #f8e2cf;
        }
    } 

    /deep/ .arco-table-tr:nth-of-type(2){
        .arco-table-cell-with-filter{
            color: #999;
        }
    } 

    /deep/ .arco-table-tr:nth-of-type(4){
        font-weight: 600;
    }
}

.shipTable{
    /deep/ .arco-table-tr:nth-of-type(1){
        .arco-table-th:nth-of-type(2){
            background: #e4f8d4;
        }
    }

    /deep/ .arco-table-tr:nth-of-type(2){
        .arco-table-cell-with-filter{
            color: #999;
        }
    } 

    /deep/ .arco-table-tr:nth-of-type(13){
        font-weight: 600;
    }

    /deep/ .arco-table-tr:nth-of-type(13){
        .arco-table-td{
            padding: 10px 0;
        }
    }
}

.slot_cell{
    display: flex;

    .slot_cell_left{
        display: flex;
        flex: 2;
        border-right: 1px solid #eee;
        align-items: center;
        justify-content: center;
    }
    .slot_cell_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 35px;
        background: #f8f8f8;
        font-size: 11px;
        align-items: center;
        justify-content: center;

        .slot_cell_right_bottom{
            color: red;
        }
    }
}

.warehouse{
    display: flex;

    .warehouse_left{
        display: flex;
        flex: 3;
        border-right: 1px solid #eee;
        position: relative;
        font-weight: 600;
        align-items: center;
        justify-content: center;
    }

    .warehouse_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        font-weight: 400;
        font-size: 15px;
        justify-content: center;
        align-items: center;

        .warehouse_right_top,
        .warehouse_right_center{
            border-bottom: 1px solid #eee;
            height: 40px;
            width: 70px;
            line-height: 40px;
        }

        .warehouse_right_bottom{
            height: 40px;
            width: 70px;
            line-height: 40px;
        }
    }
}


.countBar{
    display: inline-block;
    width: fit-content;
    font-size:12px;
    font-weight: 600;
}

/deep/ .arco-alert{
    padding: 1px 15px;
    vertical-align: bottom;

    .arco-alert-icon,
    .arco-alert-body{
        display: inline-block;
    }
}


</style>